import type { ReactNode } from 'react';
import { NavLink, useNavigate } from '../router';

import { useAuth } from '../auth';
import { Brand } from './Brand';
import { Icon } from './Icon';

const navigation = [
  { to: '/app/inbox', label: 'Messages', icon: 'chat_bubble' },
  { to: '/app/compose', label: 'New message', icon: 'edit_square' },
  { to: '/app/campaigns', label: 'Campaigns', icon: 'campaign' },
  { to: '/app/devices', label: 'Devices', icon: 'devices' },
  { to: '/app/billing', label: 'Plan', icon: 'workspace_premium' },
  { to: '/app/settings', label: 'Settings', icon: 'settings' },
];

const mobileNavigation = navigation.filter((item) => item.to !== '/app/billing');

export function AppShell({ children }: { children: ReactNode }) {
  const { account, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="app-shell">
      <aside className="side-rail">
        <Brand />
        <NavLink className="compose-rail" to="/app/compose"><Icon name="edit" /> <span>New message</span></NavLink>
        <nav aria-label="Application navigation">
          {navigation.filter((item) => item.to !== '/app/compose').map((item) => (
            <NavLink key={item.to} to={item.to}><Icon name={item.icon} /><span>{item.label}</span></NavLink>
          ))}
        </nav>
        <div className="rail-account">
          <span className="avatar">{account?.displayName.slice(0, 1).toUpperCase()}</span>
          <span><strong>{account?.displayName}</strong><small>{account?.email}</small></span>
          <button className="icon-button" type="button" aria-label="Sign out" onClick={() => void logout().then(() => navigate('/'))}><Icon name="logout" /></button>
        </div>
      </aside>
      <main className="app-main">{children}</main>
      <nav className="bottom-nav" aria-label="Mobile application navigation">
        {mobileNavigation.map((item) => (
          <NavLink key={item.to} to={item.to}><Icon name={item.icon} /><span>{item.label === 'New message' ? 'Compose' : item.label}</span></NavLink>
        ))}
      </nav>
    </div>
  );
}
